import { render, staticRenderFns } from "./OperaProjectLbaelWindow.vue?vue&type=template&id=020556d8&scoped=true&"
import script from "./OperaProjectLbaelWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectLbaelWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectLbaelWindow.vue?vue&type=style&index=0&id=020556d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020556d8",
  null
  
)

export default component.exports